module.exports = __webpack_public_path__ + "img/20200515_161803.6b8071f9.jpg";